import { useEffect } from "react";

const DEFAULT_IMAGE = "https://images.pexels.com/photos/33101042/pexels-photo-33101042.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=630&w=1200";
const SITE = "Zcardon";

function upsertMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Set per-route <title>, meta description, canonical, and OG/Twitter tags.
 * Call at the top of a page component.
 */
export function useSeo({ title, description, image, path }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE}` : SITE;
    const img = image || DEFAULT_IMAGE;
    const canonical = path ? `${window.location.origin}${path}` : window.location.href;

    document.title = fullTitle;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:image", img);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:type", "website");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", img);
    upsertCanonical(canonical);
  }, [title, description, image, path]);
}
